<template>
  <div>
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <!-- 主图 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Main Picture"
      >
        <a-upload
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        >
          <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              Upload
            </div>
          </div>
        </a-upload>
      </a-form-item>
      <!-- 城市 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="City"
      >
        <a-select
          v-decorator="[
            'city',
            {rules: [{ required: false, message: 'Please select your city!' }]}
          ]"
          :showArrow="true"
        >
          <a-select-option value="">All</a-select-option>
          <a-select-option value="Taipei">Taipei</a-select-option>
          <a-select-option value="Beijing">Beijing</a-select-option>
          <a-select-option value="Los Angeles">Los Angeles</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 中文名称 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Chinese Name"
      >
        <a-input
          v-decorator="[
            'name',
            {rules: [{ required: false, message: 'Please input your chinese name!' }]}
          ]"
          placeholder="Please input your chinese name"
        />
      </a-form-item>
      <!-- 英文名称 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="English Name"
      >
        <a-input
          v-decorator="[
            'enName',
            {rules: [{ required: false, message: 'Please input your english name!' }]}
          ]"
          placeholder="Please input your english name"
        />
      </a-form-item>
      <!-- 链接 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Chinese Link"
      >
        <a-input
          v-decorator="[
            'hotelLink',
            {rules: [{ required: false, message: 'Please input your chinese link!' }]}
          ]"
          placeholder="Please input your chinese link"
        />
      </a-form-item>
      <!-- 链接 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="English Link"
      >
        <a-input
          v-decorator="[
            'hotelEnLink',
            {rules: [{ required: false, message: 'Please input your english link!' }]}
          ]"
          placeholder="Please input your english link"
        />
      </a-form-item>
      <!-- 中文描述 -->
      <a-form-item
        :labelCol="labelCol"
        label="Chinese Description"
        hasFeedback
      >
        <ma-editor>
        </ma-editor>
      </a-form-item>
      <!-- 英文描述 -->
      <a-form-item
        :labelCol="labelCol"
        label="English Description"
        hasFeedback
      >
        <ma-editor>
        </ma-editor>
      </a-form-item>
      <!-- 房型设定 -->
      <a-form-item
        :labelCol="labelCol"
        label="Room Arrangements"
        :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 18 }
        }"
      >
        <a-button type="dashed" style="width: 60%" @click="handleRoomArrangementsAdd"> <a-icon type="plus" /> Add </a-button>
      </a-form-item>
      <!-- DestCodes -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="DestCodes"
      >
        <a-select
          v-decorator="[
            'destCodes',
            {rules: [{ required: false, message: 'Please select your dest codes!' }]}
          ]"
          mode="multiple"
          :showArrow="true"
        >
          <a-select-option value="">All</a-select-option>
          <a-select-option value="TWN">TWN</a-select-option>
          <a-select-option value="CHN">CHN</a-select-option>
          <a-select-option value="JPN">JPN</a-select-option>
        </a-select>
      </a-form-item>
      <!-- TourTypes -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="TourTypes"
      >
        <a-select
          v-decorator="[
            'tourTypes',
            {rules: [{ required: false, message: 'Please select your tour types!' }]}
          ]"
          mode="multiple"
          :showArrow="true"
        >
          <a-select-option value="">All</a-select-option>
          <a-select-option value="W">W</a-select-option>
          <a-select-option value="C">C</a-select-option>
          <a-select-option value="CE">CE</a-select-option>
        </a-select>
      </a-form-item>
      <!-- Type -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Type"
      >
        <a-select
          v-decorator="[
            'Type',
            {rules: [{ required: false, message: 'Please select your type!' }]}
          ]"
          :showArrow="true"
        >
          <a-select-option value="">All</a-select-option>
          <a-select-option value="1">酒店</a-select-option>
          <a-select-option value="2">火車</a-select-option>
          <a-select-option value="3">游輪</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 启用状态 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Enable/Disable"
        hasFeedBack
      >
        <a-switch v-decorator="['enabled', { valuePropName: 'checked' }]" />
      </a-form-item>
      <!-- 同步中英文启用状态 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Auto Sync"
        hasFeedBack
      >
        <a-switch v-decorator="['autoSync', { valuePropName: 'checked' }]" />
      </a-form-item>
    </a-form>
    <div>
      <hotel-room
        :roomNum="roomBookNum" 
        @cancel="() => { this.roomBookNum = null }"
        @confirm="() => { this.roomBookNum = null }"
      />
    </div>
  </div>
</template>

<script>
import MaEditor from '@/components/ma/MaTinyMCE'
import HotelRoom from './HotelRoomArrangements'

export default {
  name: 'HotelBasic',
  components: {
    MaEditor,
    HotelRoom
  },
  props: {
  },
  data () {
    return {
      loading: false,
      imageUrl: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      roomBookNum: null
    }
  },
  mounted () {
  },
  methods: {
    handleRoomArrangementsAdd () {
      this.roomBookNum = 'true'
    },
    handleSubmit (e) {
      e.preventDefault()
    }
  }
}
</script>
<style lang="less" scoped>
.ant-btn-dashed {
  background: #fff;
}
</style>